import { Component } from 'react'
import { connect } from 'react-redux'
import { fetchSeaLiceData } from 'reducers/seaLice/reducer'
import { LIST_VIEW_BARRIOS } from 'helpers/seaLice'

class SeaLiceDataLoader extends Component {
  componentDidUpdate(prevProps) {
    const {
      activeView,
      activeBarrios,
      activeSpecies,
      activeDate,
      fetchSeaLiceData,
    } = this.props

    if (
      activeView !== prevProps.activeView ||
      (activeView === LIST_VIEW_BARRIOS &&
        activeBarrios !== prevProps.activeBarrios) ||
      activeSpecies !== prevProps.activeSpecies ||
      activeDate !== prevProps.activeDate
    ) {
      fetchSeaLiceData({
        group: activeView,
        neighborhood: 0,
        species: +activeSpecies,
        date: activeDate.format('YYYY-MM-DD'),
      })
    }
  }

  render() {
    return null
  }
}

export default connect(
  state => ({
    activeView: state.getIn(['seaLice', 'activeView']),
    activeBarrios: state.getIn(['seaLice', 'activeBarrios']),
    activeSpecies: state.getIn(['seaLice', 'activeSpecies']),
    activeDate: state.getIn(['seaLice', 'activeDate']),
  }),
  {
    fetchSeaLiceData,
  },
)(SeaLiceDataLoader)
